import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import React from "react";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';
import BASE_URL from "../../utils/baseUrl";

const ConcernDataShow = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  //   const rows = [];
  const token = localStorage.getItem("authToken");
  const [data, setData] = React.useState([]);

  React.useEffect(() => {
    getConcernDataByID();
  }, []);

  const getConcernDataByID = () => {
    axios
      .get(`${BASE_URL}/concernData/${id}`, {
        headers: {
          token: token,
        },
      })
      .then((_data) => {
        console.log("APIDATA:::", _data.data);
        setData(_data.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const createdAt = new Date(
    data?.createdAt?._seconds * 1000
  ).toLocaleDateString("en-US");
    
    const handleEditClick = (id) => {
        console.log("EDIT::",id);
    }

  return (
    <>
       <KeyboardBackspaceIcon onClick={() => { navigate(-1) }} sx={{ mb: '25px', cursor: 'pointer' }} />
      <Card sx={{ maxWidth: 345 }}>
        <CardActionArea>
          <CardMedia
            component="img"
            height="140"
            image={data.image}
            alt={data.isEnglishTitle}
          />
          <CardContent>
            <Typography gutterBottom variant="h5" component="div">
              {data.isEnglishTitle}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Bengali Title: {data.isBengaliTitle}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Type: {data.type}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Created At: {createdAt}
            </Typography>
            {/* Edit Button */}
            <Button
              startIcon={<EditIcon />}
              onClick={()=>handleEditClick(data.id)}
              sx={{ mt: '10px' }} // Adjust margin as needed
            >
              Edit
            </Button>
          </CardContent>
        </CardActionArea>
      </Card>
    </>
  );
};

export default ConcernDataShow;